import { render, staticRenderFns } from "./myTeacher.vue?vue&type=template&id=79375df5"
import script from "./myTeacher.vue?vue&type=script&lang=js"
export * from "./myTeacher.vue?vue&type=script&lang=js"
import style0 from "./myTeacher.vue?vue&type=style&index=0&id=79375df5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports